module.exports = __webpack_public_path__ + "img/img07.e23bc37d.png";